import {
  AnchorButton,
  AnchorButtonProps,
  Position,
  Spinner,
  SpinnerSize,
} from '@blueprintjs/core';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

export const MessageButton: React.VFC<{
  buttonProps?: AnchorButtonProps;
  buttonTooltip?: string;
  disabled?: boolean;
  pending?: boolean;
  tooltipPosition?: Position;
}> = ({
  buttonProps,
  buttonTooltip,
  disabled,
  pending,
  tooltipPosition = Position.TOP,
}) => {
  if (pending) {
    return <Spinner size={SpinnerSize.SMALL} />;
  }

  if (buttonProps) {
    return (
      <Tooltip
        content={buttonTooltip || ''}
        disabled={!buttonTooltip}
        position={tooltipPosition}
      >
        <AnchorButton
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...buttonProps}
          disabled={disabled || buttonProps.disabled}
        />
      </Tooltip>
    );
  }
  return null;
};
